import { render, staticRenderFns } from "./CreateAffiliatePartner.vue?vue&type=template&id=b16e33bc"
import script from "./CreateAffiliatePartner.vue?vue&type=script&lang=js"
export * from "./CreateAffiliatePartner.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/flexben_create_affiliate_partner.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports